import { render, staticRenderFns } from "./persisted_pagination.vue.js?vue&type=template&id=1b35bf08!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./persisted_pagination.vue?vue&type=template&id=1b35bf08"
import script from "./persisted_pagination.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./persisted_pagination.vue?vue&type=script&lang=js"
export * from "./persisted_pagination.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./persisted_pagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports